/**
 * StockSense AI Premium Theme System
 * 5 High-End Visual Themes for Stock Prediction Dashboard
 */

export const themes = {
  neonWealth: {
    id: 'neonWealth',
    name: 'Neon Wealth',
    description: 'Luxury fintech with emerald neon accents',
    
    // Page Background
    pageBackground: 'bg-gradient-to-br from-slate-950 via-blue-950 to-slate-950',
    pageOverlay: 'bg-blue-900/5',
    
    // Card Styling
    cardBase: 'bg-slate-900/60 backdrop-blur-xl',
    cardBorder: 'border-slate-700/50',
    cardShadow: 'shadow-2xl shadow-blue-900/20',
    cardHover: 'hover:shadow-3xl hover:shadow-blue-500/30',
    
    // Text Colors
    textPrimary: 'text-slate-50',
    textSecondary: 'text-blue-200/70',
    textMuted: 'text-slate-400',
    
    // Button Styling
    buttonBg: 'bg-blue-600',
    buttonHover: 'hover:bg-blue-700',
    buttonText: 'text-white',
    
    // Card-Specific Accents
    predictedStocks: {
      accent: 'emerald',
      gradient: 'from-emerald-500/20 to-emerald-600/10',
      border: 'border-emerald-500/30',
      glow: 'shadow-emerald-500/20',
      hoverBorder: 'hover:border-emerald-500/50',
      hoverGlow: 'hover:shadow-emerald-500/40',
      icon: 'text-emerald-400',
      text: 'text-emerald-100',
      number: 'from-emerald-300 via-emerald-400 to-emerald-300',
      badge: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
    },
    
    history: {
      accent: 'purple',
      gradient: 'from-purple-500/20 to-purple-600/10',
      border: 'border-purple-500/30',
      glow: 'shadow-purple-500/20',
      hoverBorder: 'hover:border-purple-500/50',
      hoverGlow: 'hover:shadow-purple-500/40',
      icon: 'text-purple-400',
      text: 'text-purple-100',
      number: 'from-purple-300 via-purple-400 to-purple-300',
      badge: 'bg-purple-500/20 text-purple-400 border-purple-500/30',
    },
    
    analytics: {
      accent: 'cyan',
      gradient: 'from-cyan-500/20 to-cyan-600/10',
      border: 'border-cyan-500/30',
      glow: 'shadow-cyan-500/20',
      hoverBorder: 'hover:border-cyan-500/50',
      hoverGlow: 'hover:shadow-cyan-500/40',
      icon: 'text-cyan-400',
      text: 'text-cyan-100',
      number: 'from-cyan-300 via-cyan-400 to-cyan-300',
      badge: 'bg-cyan-500/20 text-cyan-400 border-cyan-500/30',
    },
    
    admin: {
      accent: 'rose',
      gradient: 'from-rose-500/20 to-rose-600/10',
      border: 'border-rose-500/30',
      glow: 'shadow-rose-500/20',
      hoverBorder: 'hover:border-rose-500/50',
      hoverGlow: 'hover:shadow-rose-500/40',
      icon: 'text-rose-400',
      text: 'text-rose-100',
      number: 'from-rose-300 via-rose-400 to-rose-300',
      badge: 'bg-rose-500/20 text-rose-400 border-rose-500/30',
    },
  },

  midnightGold: {
    id: 'midnightGold',
    name: 'Midnight Gold',
    description: 'Elite wealth with gold accents',
    
    pageBackground: 'bg-gradient-to-br from-black via-slate-900 to-slate-950',
    pageOverlay: 'bg-amber-900/5',
    
    cardBase: 'bg-slate-950/80 backdrop-blur-xl',
    cardBorder: 'border-amber-900/30',
    cardShadow: 'shadow-2xl shadow-amber-900/10',
    cardHover: 'hover:shadow-3xl hover:shadow-amber-500/20',
    
    textPrimary: 'text-amber-50',
    textSecondary: 'text-amber-200/60',
    textMuted: 'text-slate-500',
    
    buttonBg: 'bg-amber-600',
    buttonHover: 'hover:bg-amber-700',
    buttonText: 'text-black',
    
    predictedStocks: {
      accent: 'amber',
      gradient: 'from-amber-500/20 to-yellow-600/10',
      border: 'border-amber-500/40',
      glow: 'shadow-amber-500/20',
      hoverBorder: 'hover:border-amber-400/60',
      hoverGlow: 'hover:shadow-amber-400/40',
      icon: 'text-amber-400',
      text: 'text-amber-50',
      number: 'from-amber-300 via-amber-400 to-yellow-300',
      badge: 'bg-amber-500/20 text-amber-300 border-amber-500/40',
    },
    
    history: {
      accent: 'orange',
      gradient: 'from-orange-600/20 to-amber-700/10',
      border: 'border-orange-600/40',
      glow: 'shadow-orange-600/20',
      hoverBorder: 'hover:border-orange-500/60',
      hoverGlow: 'hover:shadow-orange-500/40',
      icon: 'text-orange-400',
      text: 'text-orange-50',
      number: 'from-orange-300 via-orange-400 to-amber-300',
      badge: 'bg-orange-500/20 text-orange-300 border-orange-500/40',
    },
    
    analytics: {
      accent: 'blue',
      gradient: 'from-blue-600/20 to-blue-700/10',
      border: 'border-blue-600/40',
      glow: 'shadow-blue-600/20',
      hoverBorder: 'hover:border-blue-500/60',
      hoverGlow: 'hover:shadow-blue-500/40',
      icon: 'text-blue-400',
      text: 'text-blue-50',
      number: 'from-blue-300 via-blue-400 to-blue-300',
      badge: 'bg-blue-500/20 text-blue-300 border-blue-500/40',
    },
    
    admin: {
      accent: 'red',
      gradient: 'from-red-700/20 to-orange-800/10',
      border: 'border-red-700/40',
      glow: 'shadow-red-700/20',
      hoverBorder: 'hover:border-red-600/60',
      hoverGlow: 'hover:shadow-red-600/40',
      icon: 'text-red-400',
      text: 'text-red-50',
      number: 'from-red-300 via-red-400 to-orange-300',
      badge: 'bg-red-500/20 text-red-300 border-red-500/40',
    },
  },

  cyberBlue: {
    id: 'cyberBlue',
    name: 'Cyber Blue',
    description: 'Futuristic AI trading terminal',
    
    pageBackground: 'bg-gradient-to-br from-blue-950 via-cyan-950 to-blue-950',
    pageOverlay: 'bg-cyan-500/5',
    
    cardBase: 'bg-blue-950/70 backdrop-blur-xl',
    cardBorder: 'border-cyan-500/40',
    cardShadow: 'shadow-2xl shadow-cyan-500/20',
    cardHover: 'hover:shadow-3xl hover:shadow-cyan-400/40',
    
    textPrimary: 'text-cyan-50',
    textSecondary: 'text-cyan-200/70',
    textMuted: 'text-blue-300/50',
    
    buttonBg: 'bg-cyan-600',
    buttonHover: 'hover:bg-cyan-500',
    buttonText: 'text-black',
    
    predictedStocks: {
      accent: 'lime',
      gradient: 'from-lime-500/20 to-green-600/10',
      border: 'border-lime-500/50',
      glow: 'shadow-lime-500/30',
      hoverBorder: 'hover:border-lime-400/70',
      hoverGlow: 'hover:shadow-lime-400/50',
      icon: 'text-lime-400',
      text: 'text-lime-50',
      number: 'from-lime-300 via-lime-400 to-green-300',
      badge: 'bg-lime-500/20 text-lime-300 border-lime-500/50',
    },
    
    history: {
      accent: 'violet',
      gradient: 'from-violet-500/20 to-purple-600/10',
      border: 'border-violet-500/50',
      glow: 'shadow-violet-500/30',
      hoverBorder: 'hover:border-violet-400/70',
      hoverGlow: 'hover:shadow-violet-400/50',
      icon: 'text-violet-400',
      text: 'text-violet-50',
      number: 'from-violet-300 via-violet-400 to-purple-300',
      badge: 'bg-violet-500/20 text-violet-300 border-violet-500/50',
    },
    
    analytics: {
      accent: 'sky',
      gradient: 'from-sky-500/20 to-cyan-600/10',
      border: 'border-sky-500/50',
      glow: 'shadow-sky-500/30',
      hoverBorder: 'hover:border-sky-400/70',
      hoverGlow: 'hover:shadow-sky-400/50',
      icon: 'text-sky-300',
      text: 'text-sky-50',
      number: 'from-sky-200 via-sky-300 to-cyan-300',
      badge: 'bg-sky-500/20 text-sky-300 border-sky-500/50',
    },
    
    admin: {
      accent: 'fuchsia',
      gradient: 'from-fuchsia-600/20 to-pink-700/10',
      border: 'border-fuchsia-600/50',
      glow: 'shadow-fuchsia-600/30',
      hoverBorder: 'hover:border-fuchsia-500/70',
      hoverGlow: 'hover:shadow-fuchsia-500/50',
      icon: 'text-fuchsia-400',
      text: 'text-fuchsia-50',
      number: 'from-fuchsia-300 via-fuchsia-400 to-pink-300',
      badge: 'bg-fuchsia-500/20 text-fuchsia-300 border-fuchsia-500/50',
    },
  },

  graphitePro: {
    id: 'graphitePro',
    name: 'Graphite Pro',
    description: 'Serious institutional finance',
    
    pageBackground: 'bg-gradient-to-br from-slate-950 via-gray-900 to-slate-950',
    pageOverlay: 'bg-slate-800/5',
    
    cardBase: 'bg-slate-900/90 backdrop-blur-xl',
    cardBorder: 'border-slate-600/40',
    cardShadow: 'shadow-2xl shadow-slate-900/30',
    cardHover: 'hover:shadow-3xl hover:shadow-slate-700/40',
    
    textPrimary: 'text-slate-100',
    textSecondary: 'text-slate-300/70',
    textMuted: 'text-slate-500',
    
    buttonBg: 'bg-slate-700',
    buttonHover: 'hover:bg-slate-600',
    buttonText: 'text-slate-50',
    
    predictedStocks: {
      accent: 'green',
      gradient: 'from-green-700/15 to-emerald-800/10',
      border: 'border-green-700/40',
      glow: 'shadow-green-800/15',
      hoverBorder: 'hover:border-green-600/50',
      hoverGlow: 'hover:shadow-green-700/25',
      icon: 'text-green-500',
      text: 'text-green-50',
      number: 'from-green-400 via-green-500 to-emerald-400',
      badge: 'bg-green-700/20 text-green-400 border-green-700/40',
    },
    
    history: {
      accent: 'indigo',
      gradient: 'from-indigo-700/15 to-violet-800/10',
      border: 'border-indigo-700/40',
      glow: 'shadow-indigo-800/15',
      hoverBorder: 'hover:border-indigo-600/50',
      hoverGlow: 'hover:shadow-indigo-700/25',
      icon: 'text-indigo-400',
      text: 'text-indigo-50',
      number: 'from-indigo-400 via-indigo-500 to-violet-400',
      badge: 'bg-indigo-700/20 text-indigo-400 border-indigo-700/40',
    },
    
    analytics: {
      accent: 'blue',
      gradient: 'from-blue-700/15 to-blue-800/10',
      border: 'border-blue-700/40',
      glow: 'shadow-blue-800/15',
      hoverBorder: 'hover:border-blue-600/50',
      hoverGlow: 'hover:shadow-blue-700/25',
      icon: 'text-blue-400',
      text: 'text-blue-50',
      number: 'from-blue-400 via-blue-500 to-blue-400',
      badge: 'bg-blue-700/20 text-blue-400 border-blue-700/40',
    },
    
    admin: {
      accent: 'red',
      gradient: 'from-red-800/15 to-red-900/10',
      border: 'border-red-800/40',
      glow: 'shadow-red-900/15',
      hoverBorder: 'hover:border-red-700/50',
      hoverGlow: 'hover:shadow-red-800/25',
      icon: 'text-red-400',
      text: 'text-red-50',
      number: 'from-red-400 via-red-500 to-red-400',
      badge: 'bg-red-800/20 text-red-400 border-red-800/40',
    },
  },

  auroraPulse: {
    id: 'auroraPulse',
    name: 'Aurora Pulse',
    description: 'Energetic modern AI app',
    
    pageBackground: 'bg-gradient-to-br from-purple-950 via-indigo-950 to-blue-950',
    pageOverlay: 'bg-purple-500/5',
    
    cardBase: 'bg-purple-950/60 backdrop-blur-xl',
    cardBorder: 'border-purple-500/40',
    cardShadow: 'shadow-2xl shadow-purple-500/20',
    cardHover: 'hover:shadow-3xl hover:shadow-purple-400/40',
    
    textPrimary: 'text-purple-50',
    textSecondary: 'text-purple-200/70',
    textMuted: 'text-indigo-300/50',
    
    buttonBg: 'bg-purple-600',
    buttonHover: 'hover:bg-purple-500',
    buttonText: 'text-white',
    
    predictedStocks: {
      accent: 'green',
      gradient: 'from-green-500/20 to-emerald-600/10',
      border: 'border-green-500/50',
      glow: 'shadow-green-500/30',
      hoverBorder: 'hover:border-green-400/70',
      hoverGlow: 'hover:shadow-green-400/50',
      icon: 'text-green-400',
      text: 'text-green-50',
      number: 'from-green-300 via-green-400 to-emerald-300',
      badge: 'bg-green-500/20 text-green-300 border-green-500/50',
    },
    
    history: {
      accent: 'pink',
      gradient: 'from-pink-500/20 to-fuchsia-600/10',
      border: 'border-pink-500/50',
      glow: 'shadow-pink-500/30',
      hoverBorder: 'hover:border-pink-400/70',
      hoverGlow: 'hover:shadow-pink-400/50',
      icon: 'text-pink-400',
      text: 'text-pink-50',
      number: 'from-pink-300 via-pink-400 to-fuchsia-300',
      badge: 'bg-pink-500/20 text-pink-300 border-pink-500/50',
    },
    
    analytics: {
      accent: 'teal',
      gradient: 'from-teal-500/20 to-cyan-600/10',
      border: 'border-teal-500/50',
      glow: 'shadow-teal-500/30',
      hoverBorder: 'hover:border-teal-400/70',
      hoverGlow: 'hover:shadow-teal-400/50',
      icon: 'text-teal-300',
      text: 'text-teal-50',
      number: 'from-teal-300 via-teal-400 to-cyan-300',
      badge: 'bg-teal-500/20 text-teal-300 border-teal-500/50',
    },
    
    admin: {
      accent: 'orange',
      gradient: 'from-orange-600/20 to-red-700/10',
      border: 'border-orange-600/50',
      glow: 'shadow-orange-600/30',
      hoverBorder: 'hover:border-orange-500/70',
      hoverGlow: 'hover:shadow-orange-500/50',
      icon: 'text-orange-400',
      text: 'text-orange-50',
      number: 'from-orange-300 via-orange-400 to-red-300',
      badge: 'bg-orange-500/20 text-orange-300 border-orange-500/50',
    },
  },
};

export const themesList = Object.keys(themes);
export const defaultTheme = 'neonWealth';
